import { Link } from "react-router-dom"

export default function BreadCrumbs({ crumbs }) {
    return (
        <nav aria-label="breadcrumb" style={{ paddingTop: "40px" }}>
            <ol className="breadcrumb p-3 bg-body-tertiary rounded-3 mt-5">
                <li className="breadcrumb-item">
                    <Link className="link-body-emphasis" title="Home" to={`/`}>
                        <i className="bi bi-house-fill"></i>
                        <span className="visually-hidden">Home</span>
                    </Link>
                </li>

                {crumbs?.length > 0 &&
                    crumbs.map((crumb, index) => (
                        <li className="breadcrumb-item" key={index}>
                            <Link
                                className="link-body-emphasis fw-semibold text-decoration-none"
                                title={crumb.name}
                                to={crumb.path}
                            >
                                {crumb.name}
                            </Link>
                        </li>
                    ))}
            </ol>
        </nav>
    )
}
